import { Map } from 'immutable';
import { bindActionCreators } from 'redux';
import { connect } from '../../../../../common/react-redux';
import makeEditable from '../../../../../common/components/shared/functionality/makeEditable';
import * as alertActions from '../../../../../common/actions/alerts';
import * as errorsShowingActions from '../../../../../common/actions/errorsShowing';
import * as itemApiActions from '../../../../api/items';
import * as modalActions from '../../../../../common/actions/modal';
import { set as setUI, newActiveBank } from '../../../../../common/actions/ui';
import * as modificationActions from '../../../../../common/actions/modifications';
import * as quizEntryApiActions from '../../../../api/quizEntries';
import { featureOn } from '../../../../../common/util/featureCheck';
import { ADD_CONTENT_POPOVER_KEY } from '@instructure/quiz-common';
import QuizEntryEdit from './presenter';
function mapStateToProps(state, props) {
  // Error Related:
  var workingEntry = props.entry.getWorkingInstance();
  var errorsShowing = state.get('errorsShowing', Map());
  var errorsAreShowing = errorsShowing.get(props.guid);
  var addContentPopoverOpen = state.get('editing', Map()).find(function (isEditing, key) {
    return isEditing && key.includes(ADD_CONTENT_POPOVER_KEY);
  });
  var dndPosition = state.getIn(['dragAndDrop', 'position']);
  var draggingAboveHalf = state.getIn(['dragAndDrop', 'aboveHalf'], false);
  var draggingOver = props.draggingOnBuild && dndPosition === props.quizEntry.position;
  var richFITBInteraction = state.getIn(['interactionTypes'], Map()).find(function (interactionType) {
    return interactionType.get('slug') === 'rich-fill-blank';
  });
  return {
    addContentPopoverOpen: Boolean(addContentPopoverOpen),
    appContainer: state.getIn(['ui', 'appContainer']),
    draggingAboveHalf: draggingOver && draggingAboveHalf,
    draggingOver: draggingOver,
    editable: true,
    errors: workingEntry.getErrors().toJS(),
    errorsAreShowing: errorsAreShowing,
    isEditing: true,
    isOccluded: state.getIn(['ui', 'quizEntriesOccluded'], false),
    nextQuizEntry: state.getIn(['modifications', 'nextQuizEntry'], null),
    notifyScreenReader: true,
    richFITBEnabled: featureOn('interaction_type_rich_fill_blank'),
    richFITBInteractionID: (richFITBInteraction || Map()).get('id'),
    stemErrors: workingEntry.errorsFor('itemBody').toJS(),
    workingEntry: workingEntry,
    workingQuizEntry: props.quizEntry.getWorkingInstance()
  };
}
function mapDispatchToProps(dispatch) {
  var boundErrorActions = bindActionCreators(errorsShowingActions, dispatch);
  var boundItemApiActions = bindActionCreators(itemApiActions, dispatch);
  var boundModalActions = bindActionCreators(modalActions, dispatch);
  var boundModificationActions = bindActionCreators(modificationActions, dispatch);
  var boundQuizEntryApiActions = bindActionCreators(quizEntryApiActions, dispatch);
  return {
    screenreaderNotification: bindActionCreators(alertActions, dispatch).screenreaderNotification,
    setUI: bindActionCreators(setUI, dispatch),
    newActiveBank: bindActionCreators(newActiveBank, dispatch),
    changeItemTitle: boundModificationActions.changeItemTitle,
    changeQuizEntryPoints: boundModificationActions.changeQuizEntryPoints,
    clearModifications: boundModificationActions.clearModifications,
    clearTemporaryItem: boundModificationActions.clearTemporaryItem,
    clearNextQuizEntry: boundModificationActions.clearNextQuizEntry,
    hideError: boundErrorActions.hideError,
    showError: boundErrorActions.showError,
    createTempItem: boundModificationActions.createItem,
    createTempStimulus: boundModificationActions.createStimulus,
    createItem: boundItemApiActions.createItem,
    updateItem: boundItemApiActions.updateItem,
    cloneQuizEntry: boundQuizEntryApiActions.cloneQuizEntry,
    createQuizEntry: boundQuizEntryApiActions.createQuizEntry,
    removeQuizEntry: boundQuizEntryApiActions.removeQuizEntry,
    updateQuizEntry: boundQuizEntryApiActions.updateQuizEntry,
    openModal: boundModalActions.openModal,
    withConfirm: boundModalActions.withConfirm
  };
}
export default makeEditable(connect(mapStateToProps, mapDispatchToProps)(QuizEntryEdit));